import {
    FURUI_CHOOSE_CURRENT_FRUI_QPGOODS,
} from './constants';
  
export function chooseCurrentFrui_qpgoods(modal) {
    return {
      type: FURUI_CHOOSE_CURRENT_FRUI_QPGOODS,
      data: modal,
    };
}
  
export function reducer(state, action) {
    switch (action.type) {
      case FURUI_CHOOSE_CURRENT_FRUI_QPGOODS:
        return {
          ...state,
          currentFrui_qpgoods:action.data,
        };
  
      default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/features/furui/redux/chooseCurrentFrui_qpgoods.js